import React, { Fragment } from 'react'


import {  Navigate } from 'react-router-dom'
import { connect } from 'react-redux'
import NProgress from 'nprogress'
// import { Helmet } from 'react-helmet'
// import Loader from 'components/cleanui/layout/Loader'
import PublicLayout from './Public'
import AuthLayout   from './Auth'
import MainLayout   from './Main'
import ParkLayout   from './Park'
import AppatchLayout   from './Appatch'
import KioskLayout  from './Kiosk'




 
const Layouts = {
  public:  PublicLayout,
  policy: PublicLayout,
  auth: AuthLayout,
  main: MainLayout,
  park: ParkLayout,
  appatch: AppatchLayout,
  kiosk: KioskLayout,
}

const mapStateToProps = ({ auth }) => ({ auth })
let previousPath = ''

const Layout = ({ auth, children, location: { pathname, search } }) => {
  // NProgress & ScrollTop Management
  const currentPath = pathname + search
  if (currentPath !== previousPath) {
    window.scrollTo(0, 0)
    NProgress.start()
  }
  setTimeout(() => {
    NProgress.done()
    previousPath = currentPath
  }, 300)

  // Layout Rendering
  const getLayout = () => {
    // if (pathname === '/') {
    //   return 'public'
    // }
    if (/^\/auth(?=\/|$)/i.test(pathname)) {
      return 'auth'
    }
    if (/^\/park(?=\/|$)/i.test(pathname)) {
      return 'park'
    } 
    if (/^\/public(?=\/|$)/i.test(pathname)) {
      return 'public'
    }
    // Customer-facing but signed in — chrome-free like 'public', yet still requires a
    // session (the API stamps who captured the sign-up). Intentionally NOT added to
    // the unauthorized-tolerant list further down.
    if (/^\/kiosk(?=\/|$)/i.test(pathname)) {
      return 'kiosk'
    }
    if (/^\/policy(?=\/|$)/i.test(pathname)) {
      return 'policy'
    }  

    if (/^\/appatch(?=\/|$)/i.test(pathname)) {
      return 'appatch'
    }       
    return 'main'
  }

  const Container = Layouts[getLayout()]
  const isUserAuthorized  = auth?.authorized
  const isUserLoading     = auth?.loading
  const isAuthLayout      = getLayout() === 'auth'
 

  /*
  | License / Trial checks
  */
  const license_status = auth?.auth?.user?.extra?.privileges?.license_status
  const paidNotExpired =
    license_status?.type === 'paid' &&
    (!license_status?.expiry_date || new Date(license_status.expiry_date) >= new Date())
  const hasActivePaidLicense =
    paidNotExpired && (license_status?.status === 'active' || license_status?.status === 'canceled')
  const hasActiveTrial =
    license_status?.type === 'trial' &&
    license_status?.status === 'active' &&
    license_status?.expiry_date &&
    new Date(license_status.expiry_date) >= new Date()
  const hasValidAccess = hasActivePaidLicense || hasActiveTrial
  const isTrialExpired =
    license_status?.type === 'trial' &&
    new Date(license_status?.expiry_date) < new Date()
  const isLicenseRoute = /^\/licenses(?=\/|$)/i.test(pathname)
  

  const BootstrappedLayout = () => {

    // show loader when user in check authorization process, not authorized yet and not on login pages
    if (isUserLoading && !isUserAuthorized && !isAuthLayout) {
      return null
    }
    // if(isAuthLayout && isUserAuthorized){
    //   return <Navigate to="/dashboard" />
    // }  
    // Redirect users without valid access (no active paid license and no active trial) to /licenses
    if (isUserAuthorized && !hasValidAccess && !isLicenseRoute) {
      return <Navigate to="/licenses" replace />
    }

    // Redirect expired trial users to /licenses from anywhere except licenses pages
    if (isUserAuthorized && isTrialExpired && !isLicenseRoute) {
      return <Navigate to="/licenses" replace />
    }

    if(isAuthLayout && isUserAuthorized){
      // console.log('Navigate to="/dashboard');
      return <Navigate to="/dashboard" />
    }      
    // Navigate to login page if current is not login page and user not authorized
    if (!isAuthLayout && !isUserAuthorized) {
      
      if(getLayout() === 'public' || getLayout() === 'park' || getLayout() === 'policy' || getLayout() === 'appatch')
      {
        // return null
      } else {
        return <Navigate to="/auth/login" />
      }
    } 

    // in other case render previously set layout
    return <Container>{children}</Container>
  }

  return (
    <Fragment>
      {BootstrappedLayout()} 
    </Fragment>
  )
}

export default (connect(mapStateToProps)(Layout))
